import React, { useContext } from 'react';
import { RadioGroupVertical, LabeledToggle, Label, InfoIconWithPopover, SelectionList, SelectionListItem, Separator, MoreLink, Toggle, InfoText } from 'wix-rich-content-ui-components';
import { LTRIcon, RTLIcon } from 'wix-rich-content-plugin-commons';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { RicosContext } from 'ricos-context';
import { initialExpandedItems, listDirection, COLLAPSIBLE_LIST_TYPE } from '../../types.js';

var css_248z = ".a2zwf,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.cUegu{box-sizing:border-box;height:calc(100% - 170px);overflow:scroll;position:absolute;top:70px;width:100%}[dir] .cUegu{padding:20px}.cUegu *,.cUegu :after,.cUegu :before{box-sizing:inherit}.cUegu input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.cUegu{height:calc(100% - 50px);top:50px}}}@container (width < 640px){.cUegu{height:calc(100% - 50px);top:50px}}[dir] .GS2Ns{margin:20px 0!important}.iMIo0{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .iMIo0{margin-top:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.iMIo0{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.iMIo0{grid-template-columns:repeat(3,1fr)}}.eeGTM p{margin-block-end:1em;margin-block-start:1em}[dir] .eeGTM svg{padding-top:10px}.eeGTM p,.eeGTM svg{fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-action-color,var(--ricos-action-color,#0261ff))}._1atyg{height:22px}[dir] ._1atyg{cursor:pointer}[dir=ltr] ._1atyg{margin-left:8px}[dir=rtl] ._1atyg{margin-right:8px}._1atyg svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.ypibs{color:var(--ricos-settings-text-color,#000)}@supports not (contain:inline-size){@media only screen and (max-width:640px){.ypibs{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464))}}}@container (width < 640px){.ypibs{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464))}}.WNs17{align-items:center;display:flex;gap:8px;height:24px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .WNs17{margin-bottom:8px}}}@container (width < 640px){[dir] .WNs17{margin-bottom:8px}}.WNs17 svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}[dir] .WNs17 svg{cursor:pointer}";
var styles = {"fontElementMap":"a2zwf","settingsContainer":"cUegu","separator":"GS2Ns","direction_selector":"iMIo0","direction_selector_option":"eeGTM","qapageDataToggle_infoIcon_wrapper":"_1atyg","qapageDataToggle_infoIcon_tooltip_link":"ypibs","collapsible_label":"WNs17"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CollapsibleListSettings = ({
  onChange,
  value,
  pluginEvents,
  isQapageDataEnabled
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const renderOption = ({ item, selected }) => /* @__PURE__ */ React.createElement(SelectionListItem, { icon: /* @__PURE__ */ React.createElement(item.icon, null), selected, label: item.label });
  const expandOptions = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RadioGroupVertical,
    {
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Title"),
      value: value.initialExpanded.type,
      dataSource: [
        {
          value: initialExpandedItems.ALL,
          labelText: t(
            "CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Expanded"
          ),
          dataHook: "Expanded"
        },
        {
          value: initialExpandedItems.FIRST,
          labelText: t(
            "CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_FirstExpanded"
          ),
          dataHook: "FirstExpanded"
        },
        {
          value: initialExpandedItems.NONE,
          labelText: t(
            "CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_Collapsed"
          ),
          dataHook: "Collapsed"
        }
      ],
      t,
      onChange: (changedValue) => {
        onChange(
          (() => {
            if (changedValue === "ALL") {
              return __spreadProps(__spreadValues({}, value), {
                initialExpanded: { type: "ALL" }
              });
            }
            return __spreadProps(__spreadValues({}, value), {
              initialExpanded: {
                type: changedValue,
                expandOnlyOne: value.initialExpanded.type !== "ALL" ? value.initialExpanded.expandOnlyOne : false
              }
            });
          })()
        );
      }
    }
  ), value.initialExpanded.type !== initialExpandedItems.ALL && /* @__PURE__ */ React.createElement(
    LabeledToggle,
    {
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_CollapseView_InSections"),
      checked: !!value.initialExpanded.expandOnlyOne,
      onChange: () => {
        const expandOnlyOne = value.initialExpanded.type === "ALL" ? false : value.initialExpanded.expandOnlyOne;
        onChange(__spreadProps(__spreadValues({}, value), {
          initialExpanded: {
            type: value.initialExpanded.type,
            expandOnlyOne: !expandOnlyOne
          }
        }));
      },
      style: isMobile ? { paddingTop: "28px" } : {},
      dataHook: "onePairExpanded"
    }
  ));
  const separator = /* @__PURE__ */ React.createElement(Separator, { horizontal: true, className: styles.separator, name: "" });
  const directionOptions = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.collapsible_label }, /* @__PURE__ */ React.createElement(
    Label,
    {
      label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title"),
      isMobile
    }
  ), !isMobile && /* @__PURE__ */ React.createElement(InfoIconWithPopover, null, /* @__PURE__ */ React.createElement(React.Fragment, null, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_Title_Tooltip")))), /* @__PURE__ */ React.createElement(
    SelectionList,
    {
      dataSource: [
        {
          value: listDirection.LTR,
          label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_LTR"),
          icon: LTRIcon,
          dataHook: "ltrDirection"
        },
        {
          value: listDirection.RTL,
          label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_Direction_RTL"),
          icon: RTLIcon,
          dataHook: "rtlDirection"
        }
      ],
      renderItem: renderOption,
      value: value.direction,
      onChange: (changedValue) => {
        onChange(__spreadProps(__spreadValues({}, value), { direction: changedValue }));
      },
      className: styles.direction_selector,
      optionClassName: styles.direction_selector_option
    }
  ));
  const renderQapageToggle = () => {
    const onToggle = () => {
      var _a;
      (_a = pluginEvents == null ? void 0 : pluginEvents.onChangePluginSettings) == null ? void 0 : _a.call(pluginEvents, {
        pluginId: COLLAPSIBLE_LIST_TYPE,
        actionName: "QapageData",
        value: value.isQapageData ? "no" : "yes"
      });
      onChange(__spreadProps(__spreadValues({}, value), { isQapageData: !value.isQapageData }));
    };
    const onKeyPress = (e) => {
      if (e.key === "Enter") {
        onToggle();
      }
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, separator, /* @__PURE__ */ React.createElement("div", { className: styles.collapsible_label, tabIndex: 0, onKeyPress }, /* @__PURE__ */ React.createElement(
      Label,
      {
        label: t("CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Toggle"),
        style: isMobile ? { paddingTop: 28, paddingBottom: 12 } : { fontSize: 16 }
      }
    ), !isMobile && /* @__PURE__ */ React.createElement(InfoIconWithPopover, null, /* @__PURE__ */ React.createElement(React.Fragment, null, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Tooltip"), " ", /* @__PURE__ */ React.createElement(
      MoreLink,
      {
        t,
        link: "https://wix.wixanswers.com/app/kb/article/a5b1247b-baf3-4baa-a7f1-7137e10ca768/en"
      }
    ))), /* @__PURE__ */ React.createElement(
      Toggle,
      {
        checked: value.isQapageData,
        onChange: onToggle,
        dataHook: "isQapageDataToggle"
      }
    )), isMobile && /* @__PURE__ */ React.createElement(InfoText, null, /* @__PURE__ */ React.createElement(React.Fragment, null, t("CollapsibleList_CollapsibleListSettings_Tab_Settings_FAQ_Enabled_Tooltip"), " ", /* @__PURE__ */ React.createElement(
      MoreLink,
      {
        t,
        link: "https://wix.wixanswers.com/app/kb/article/a5b1247b-baf3-4baa-a7f1-7137e10ca768/en"
      }
    ))));
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.settingsContainer }, expandOptions, isQapageDataEnabled && renderQapageToggle(), separator, directionOptions);
};

export { CollapsibleListSettings };
//# sourceMappingURL=CollapsibleListSettings.js.map
